class LinkTypeService {

  constructor(ApiService, $q, LinkTypeSchema) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.LinkTypeSchema = LinkTypeSchema;

    this.linkTypeEndpoint = '/api/linktypes';
  }

  /**
   * Get new empty link type schema
   * @returns {*}
   */
  getNew() {
    return this.LinkTypeSchema;
  }

  /**
   * Get array of link types from server
   * @returns {*}
     */
  getAll() {
    var self = this;
    return self.ApiService.get(self.linkTypeEndpoint)
        .then( (response) => { return response.data } );
  }

}
LinkTypeService.$inject = ['ApiService', '$q', 'LinkTypeSchema'];
export default LinkTypeService;
